module.exports = __webpack_public_path__ + "static/p14-4b2f98bad381b9889375580970776416.jpg";